import { ComponentsOverrides } from "@mui/material";

const styleOverrides: ComponentsOverrides["MuiDialog"] = {
  root: {
    position: 'absolute',
  },
  scrollPaper: {
    alignItems: "flex-start",
  },
  paperScrollBody: {
    verticalAlign: "top",
  },
};

const StyledDialog = {
  styleOverrides,
};

export default StyledDialog;
